export const MODAL_TYPES = {
    EXPERIENCE_SCORE_DETAILED_INSIGHT_MODAL: 'EXPERIENCE_SCORE_DETAILED_INSIGHT_MODAL',
    EXPERIENCE_SCORE_INFO_MODAL: 'EXPERIENCE_SCORE_INFO_MODAL',
};
